import HeaderMenu from './HeaderMenu';
import HeaderLogo from './HeaderLogo';
import HeaderSettings from './HeaderSettings';
import {useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {IconButton} from '@mui/material';
import MobileSidebar from './MobileSidebar';
import LanguageChange from './LanguageChange';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpenClose = (state: boolean) => {
    setIsMenuOpen(state);
  };

  return (
    <>
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-10"
          onClick={() => handleMenuOpenClose(false)}
        />
      )}

      <div className="w-full h-[88px] bg-darkBlue flex justify-between items-center gap-3 py-1 px-4 overflow-hidden relative z-20">
        {/* logo */}
        <HeaderLogo />

        <div className="hidden lg:flex min-w-0">
          <HeaderMenu />
        </div>

        <div className="hidden lg:flex">
          <HeaderSettings />
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <LanguageChange />

          <IconButton
            onClick={() => handleMenuOpenClose(true)}
            sx={{display: {lg: 'none'}, p: 0}}>
            <MenuIcon sx={{color: '#BABCBE', fontSize: 35}} />
          </IconButton>
        </div>

        <MobileSidebar
          isMenuOpen={isMenuOpen}
          handleMenuOpenClose={handleMenuOpenClose}
        />
      </div>
    </>
  );
}

export default Header;
